module.exports = __webpack_public_path__ + "img/2tgv-e80-1400.prt.5071f9ef.jpg";